import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PaymentV2Service, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-payment-sip-donors',
  templateUrl: './payment-sip-donors.component.html',
  styleUrls: ['./payment-sip-donors.component.scss']
})
export class PaymentSipDonorsComponent implements OnInit, OnDestroy {

  @Input() label = 'donors are giving monthly';
  supporterImg;
  subs: Subscription[] = [];

  constructor(
    public paymentv2: PaymentV2Service,
    public vars: VariablesService
  ) { }

  ngOnInit() {
    this.supporterImg = `/assets/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
    this.vars.getSubsCount();
    this.subs.push(this.vars.subsCount.subscribe((res: any) => {
      this.paymentv2.sipDonors = res;
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
